// api/messages.ts — student-side inbox API typed wrappers (W6 v1.1 Session 2).

import { apiJson } from './client';

export interface InboxMessage {
  id:                string;
  body_md:           string;
  /** Instructor kinds + FP8 'system' nudge. 'system' rows render with the
   *  Il Prof identity and a CTA button (link_path). */
  kind:              'instructor_response' | 'instructor_async' | 'system';
  source_kind:       'gap_response' | 'tab4_message' | 'tab4_flag';
  source_id:         string | null;
  /** FP8 — optional in-app deep link rendered as a CTA button. */
  link_path:         string | null;
  created_at:        string;
  delivered_at:      string | null;
  author_first_name: string;
  author_last_name:  string | null;
  author_role:       'titolare' | 'instructor_teoria' | 'instructor_guida' | 'segreteria';
}

export interface InboxPayload {
  messages:     InboxMessage[];
  unread_count: number;
}

export const messagesApi = {
  async list(): Promise<InboxPayload> {
    return apiJson<InboxPayload>('/api/messages');
  },

  async markRead(messageId: string): Promise<{ read: boolean; id: string; already_read?: boolean; delivered_at?: string }> {
    return apiJson(`/api/messages/${encodeURIComponent(messageId)}/read`, {
      method: 'POST',
      body: JSON.stringify({}),
    });
  },
};
